<script lang="ts" setup>
    import { type PropType, ref } from 'vue';
    import { type MediaProps } from "@interfaces/MediaProps";
    import Media from "@/components/Media.vue";
    import VueHorizontal from "vue-horizontal";
    import { comingSoonImages } from "@/helpers/composables/comingSoonImages"
    
    let props = defineProps({
        productImages: {
            type: Array as PropType<MediaProps[]>,
            required: true
        }
    });

    let zoomControls = {
        allow: true,
        moveType: "drag",
        zoomType: "click",
        zoomPreload: true,
        hideCloseButton: true
    };

    const carouselRef = ref();
    const backToStart = ()=>{
        carouselRef?.value?.scrollToIndex(0);
    }

    defineExpose({
        backToStart
    });

</script>
<template>
    <div class="productDetails-image-carousel">
        <div class="mobile-gallery-wrapper">
            <vue-horizontal
                v-if="productImages.length > 0"
                ref="carouselRef"
                responsive
                scroll
                class="gallery-mobile"
            >
                <div class="item zoom-image-container" v-for="(image, i) in productImages" :key="`${image.media ?? ''}-${i}`">
                    <Media
                        v-bind="{ 
                            ...image,
                            zoomControls
                        }"
                        mediaClasses="w-image main-image" alt=""
                    />
                </div>
                <template v-slot:btn-next><span></span></template>
                <template v-slot:btn-prev><span></span></template>
            </vue-horizontal>
            <div v-else class="gallery-mobile">
                <Media
                    v-bind="{ media: comingSoonImages().large }"
                    mediaClasses="item zoom-image-container item" alt=""
                />
            </div>
            <span class="action-button">
                <slot></slot>
            </span>
        </div> 
    </div>
</template>